 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonpBeisenCloudUI"];
 	window["webpackJsonpBeisenCloudUI"] = function webpackJsonpCallback(chunkIds, moreModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, callbacks = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId])
 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				var _m = moreModules[moduleId];

 				// Check if module is deduplicated
 				switch(typeof _m) {
 				case "object":
 					// Module can be created from a template
 					modules[moduleId] = (function(_m) {
 						var args = _m.slice(1), templateId = _m[0];
 						return function (a,b,c) {
 							modules[templateId].apply(this, [a,b,c].concat(args));
 						};
 					}(_m));
 					break;
 				case "function":
 					// Normal module
 					modules[moduleId] = _m;
 					break;
 				default:
 					// Module is a copy of another module
 					modules[moduleId] = modules[_m];
 					break;
 				}
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
 		while(callbacks.length)
 			callbacks.shift().call(null, __webpack_require__);

 	};

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// "0" means "already loaded"
 	// Array means "loading", array contains callbacks
 	var installedChunks = {
 		1:0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;

 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			exports: {},
 			id: moduleId,
 			loaded: false
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.loaded = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
 		// "0" is the signal for "already loaded"
 		if(installedChunks[chunkId] === 0)
 			return callback.call(null, __webpack_require__);

 		// an array means "currently loading".
 		if(installedChunks[chunkId] !== undefined) {
 			installedChunks[chunkId].push(callback);
 		} else {
 			// start chunk loading
 			installedChunks[chunkId] = [callback];
 			var head = document.getElementsByTagName('head')[0];
 			var script = document.createElement('script');
 			script.type = 'text/javascript';
 			script.charset = 'utf-8';
 			script.async = true;

 			script.src = __webpack_require__.p + "1." + ({"0":"TitaFeed","2":"ReactHigncharts"}[chunkId]||chunkId) + ".bundle.js";
 			head.appendChild(script);
 		}
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// __webpack_public_path__
 	__webpack_require__.p = "";
 	(function exposeCodeSplitWebpackRegistry() {
 	              const registry = {"modules":{"f1a5b699597c":436,"1a45d3d35664":438,"264a6e06b44f":198,"db0b878e4685":197,"46828e151548":412,"7d51e0a32947":195,"67d29910d6d0":418,"ec59ed0f1c99":414,"bddbb8773fb1":415,"5e5adec0cd15":402,"4560058db664":396,"fc4fa76ab5d8":397,"1be516dde758":406,"23fd53d2f4c9":379,"14169a6195c2":405,"52c1abc2cc1a":399,"228418a78d64":408,"8073e59687f8":196,"e06546b75343":404,"d1f993ab5e87":437,"e31ec0a9fd21":413,"2e281f37dfe1":401,"c36ff8c33b57":398,"19ab487033a2":2,"60e4c7aef1d4":3,"935d89d0b2f2":417,"f76062db4111":2,"cb123ef9dd48":419,"c2c3d84d6bca":1,"7f0f2edbfc52":3,"373e5f5b77dd":4,"96c138c844a6":5,"c323d24dbfda":439,"2dd24a061747":2,"65bad1cf29a4":3,"cbebce5755eb":4,"b22ec6a1c138":5,"0f879ae88874":394,"44260205a8f5":2,"8a0092cefee0":403,"c4dcfbe2a33f":2,"70c86cd53f49":3,"00dd55deaa45":4,"de4ec68c2884":389,"086c4c79d824":2,"0a613d4377b1":110,"4ba71c307d04":420,"4c2fba76a81d":388,"a4879609013e":395,"5078978220e2":400,"f27233fbe0de":407,"4bb95cccee00":429,"b8e2c07e47fa":422,"d2c7640f2f08":435,"2b1e76ea4951":2,"fdd9ef6f78f2":411,"cf9a2a8510b5":430,"ae00f7c7c1f5":421,"994a88e781cc":2,"f2bafe0a864b":3,"bc2bb1d3d634":4,"f9a6cea995dd":5,"3766ace057a5":6,"c0ecd991f97e":7,"64705bc1f870":8,"cc1da66774bb":9,"356d283c2f48":10,"d90d6b86b3d1":11,"da0c223a1eb0":12,"690fc516c804":13,"4c20419d0d6a":14,"4e06e0af2cbf":15,"592538ab022a":16,"175af1e7fcbc":17,"c2658b300dac":393,"fe44942f5552":409,"4b6dfd37bca0":2,"47ad4a1fef1b":392,"9dc3b9bd3fb0":2,"9af4de3e1d6c":3,"51b9107cb009":390,"70aa4e0d7e26":378,"6c0786ae1ba7":2,"28cacb23a1bf":3,"9a56e0c1c04b":410,"cb6191605e08":428,"bf5b1b4770ff":432,"4272f3e515d5":434,"c50ace880d5f":2,"95aec7e8840a":391,"30807d64b570":386,"bfe182053bd8":1,"3aabb5a9cf2f":3,"69e87b4afd73":4,"0f7b51fcb1a1":5,"f0ed13c99aba":6,"3adab808e4a0":416,"a701a449f4e0":431,"cae858cef631":423,"4c0600a8b286":426,"36ea3562fce4":2,"82d3a363541c":3,"6e86b1623ce6":433,"df2d08b76cc6":385,"1abecf587773":381,"e4514373f14a":387,"9a68ff0139c2":2,"d076d4038fe1":3,"7e90a93d9827":4,"edaebc420faf":5,"bf3853d55827":6,"7b3c838113e0":7,"9b06ed44185d":8,"e5cb187691d8":382,"b6d8209f3783":424,"539186cb7e46":380,"6e439e209714":383,"943614cbe031":384,"dd411465e107":2,"3c5b226bc919":425,"9470de89d67c":2,"ceafcf4877b1":427,"0bf4e6b512f5":12,"3233be9d27d8":14,"255c204dd830":15,"ec97891f9163":16,"e75b0e37c737":20,"93df6581055e":27,"7009b26464c7":30,"2bc9ff01babf":31,"13fe4822c4d3":40,"c253c7165d26":41,"06de9e8e2364":42,"1b9b5d79a4e9":43,"fc3cf5f3bc04":47,"98789389575c":48,"e20f6e60b287":59,"823111075a16":60,"7aa33c6ce69f":61,"b3e7dba0f66d":62,"627667937826":63,"8a70dfa69803":64,"b12e9249bc57":65,"4d0ad50173c3":77,"634640a364b8":78,"0c6b165e8ebf":79,"25476091b632":80,"cb7cba5985ce":81,"2251e214afd2":82,"40650068ade6":83,"513cdec7c101":84,"461bd0b40999":85,"8bccdfeaa7ca":86,"88e45a054464":87,"e381d5bc1381":88,"6a3e1107a5a1":89,"df08e2016216":90,"41cc722d3262":91,"b18093b5f0f7":126,"cad7d8344168":127,"3181d0b09b8a":128,"f3d5ff07a805":129,"dbcde1066679":130,"172ede702147":131,"0448d4cb9e81":132,"7ca6e73b62f3":133,"7caddce433ed":134,"ccb6425e4f48":135,"b3d648ac3546":136,"82974a258a95":137,"3ce09d78d425":138,"2c1c492e2faf":139,"d02872d9a817":140,"3c5bc79d8d4d":141,"b2041fabe897":142,"0b0082cdde95":143,"b1956f449d8c":144,"282ce62dfc1a":145,"ada5c6f53d6e":146,"cefd08ac965d":147,"bdd43a01073f":148,"5650b7452d0f":149,"c9a045aba955":150,"ed6744e68091":151,"0faab218b05a":152,"eea45b39c081":153,"96cbc20656c0":154,"52f450c34db4":155,"4c3ce95184b0":156,"6226d98ca637":157,"2fee51365639":158,"958651d40fbe":159,"3ff7393c5b38":160,"160f631446b6":161,"0c280720cb7a":162,"8c2abe21115f":163,"86c2eb95818a":164,"24e8b9f907cd":165,"8e68f7b9b229":166,"524ba0c4f68c":167,"5e209a116fc2":168,"55f92822a877":169,"8babd3c34a67":170,"6ecf8827dca0":224,"eb872820fa2f":225,"61e916fdc16f":226,"e5fb0aeed9fe":227,"cec41810717d":228,"807c94f4be8b":229,"c26fd0f40cc3":230,"47827ce46d58":231,"8cfcf281e1d9":232,"eb8f5bd36223":233,"783823b0b194":234,"a94ba991f7c6":235,"695817dbbcf4":236,"30915d00228d":237,"35fa4a5c8165":238,"8ae27f024a2e":239,"55deda78138f":240,"57c1fbd4de4c":241,"76c419dde1ef":242,"f079f174a8ec":243,"6b0406d25752":244,"2d6a865087a8":245,"9bbf9f09f7c7":246,"101d7ba154d0":247,"56b9e72fe32a":248,"7234923d4a6c":249,"daa3fca7b9ce":250,"fd986fff4da4":251,"e4e85142ec44":252,"42536d72b556":253,"18f860249053":254,"e05aa9c3ac60":255,"1e95ec388a6a":256,"6997c6e1306a":257,"d59a26b2775a":258,"a2752ed62895":259,"419c5645c2e7":260,"c8efb8655f9f":261,"318ad5f63d43":262,"ed864a488b73":263,"c8db0c5053d0":264,"e175ef75a7a8":265,"1ad4bee90098":266,"70e932dd0aca":267,"44638bacf41e":268,"944b01ad9ae3":269,"fc80257894fe":270,"f49ac91e36e8":271,"b008d0255cfe":272,"d98a75eea9c8":273,"6d889a7b73bb":274,"64c5f0480f0b":275,"692bc5e6011c":276,"faefc70cbccc":277,"214a7047b5f7":278,"42122ca5efd8":279,"eeb8c27aaec4":280,"8af9a9baa9e7":281,"88fa5f1b39c0":282,"f3bab5ed42fa":283,"4cc98d42d92d":284,"0754941da196":285,"65da4ca65a73":286,"19d62be698ee":287,"49bd4cd234ee":288,"9eb2c7084ffe":289,"5f25585e6f79":290,"9244c4e62d58":291,"25e1437f58dd":292,"59fb9fda1710":293,"8998ce6f1a7d":294,"91ffe7030767":295,"31aa30152cf6":296,"3d4b845a09f0":297,"f358490d566c":298,"4afcdb6bfa1c":299},"chunks":{"TitaFeed":0,"BeisenCloudMobile":1,"ReactHigncharts":2}};
 	              if (typeof global !== 'undefined') {
 	                global.__CODE_SPLIT_MODULE_CHUNK_MAPPING__ = registry;
 	              } else if (typeof window !== 'undefined') {
 	                window.__CODE_SPLIT_MODULE_CHUNK_MAPPING__ = registry;
 	              }
 	          }());

 	// Load entry module and return exports
 	return __webpack_require__(0);



// WEBPACK FOOTER //
// webpack/bootstrap 36575783256da0e91da4